import React from 'react';
import '../../Assets/Css/ViewDepartment.scss';
import { useLocation } from 'react-router-dom';

const ViewDepartment = () => {
    const location = useLocation();
    const data = location?.state?.data?.allData;
    return (
            <div className="viewDepartment-main">
                <div className="page-title">
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>Department</h4>
                    </div>
                </div>
                <div className="content-part">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="left-part">
                                <div className="custom-row">
                                    <div className="department-detail">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className='department-detail-divider'>Department Details</h5>
                                        </div>
                                        <div className="row">
                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Name</h6>
                                                </div>
                                                <div className="col-9">
                                                    <h6 className='labels'>{data?.name}</h6>
                                                </div>
                                            </div>

                                            <div className="input-groups">
                                                <div className="col-3">
                                                    <h6 className='labels'>Parent Department</h6>
                                                </div>
                                                <div className="col-9">
                                                    <h6 className='labels'>{data?.parent_department}</h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default ViewDepartment;